// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1dm6o","left":"StickyBox_left__1hUaC","right":"StickyBox_right__2SQO3"};